import { render } from "./RecipientView.vue?vue&type=template&id=2553d102"
import script from "./RecipientView.vue?vue&type=script&lang=js"
export * from "./RecipientView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__